var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterAltCircle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_3590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.435 10.2651L26.2283 29.6068H28.495L13.87 10.2651H11.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.955 0 0 8.955 0 20C0 31.045 8.955 40 20 40C31.045 40 40 31.045 40 20C40 8.955 31.045 0 20 0ZM25.105 32.0533L18.655 23.6283L11.285 32.0533H7.18833L16.7433 21.13L6.66667 7.94667H15.1033L20.9267 15.6483L27.665 7.94667H31.7567L22.8217 18.1567L33.3333 32.0517L25.105 32.0533Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_3590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterAltCircle1);
export default __webpack_public_path__ + "static/media/twitter-alt-circle 1.c56202dd95db4e0d7239b186f003134d.svg";
export { ForwardRef as ReactComponent };